"use client";

import Bugsnag, { Event } from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import React from "react";

const API_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "";

if (!API_KEY) {
  console.warn("Bugsnag API key is missing for client");
}

const APP_VERSION = "0.1.0";
const RELEASE_STAGE = "all";

if (API_KEY && typeof window !== "undefined") {
  Bugsnag.start({
    apiKey: API_KEY,
    plugins: [new BugsnagPluginReact()],
    releaseStage: RELEASE_STAGE,
    collectUserIp: false,
    appVersion: APP_VERSION, // must be the same as upload source maps version
  });

  BugsnagPerformance.start({
    apiKey: API_KEY,
    appVersion: APP_VERSION,
    releaseStage: RELEASE_STAGE,
  });
}

const reactPlugin = Bugsnag.getPlugin("react");

export const BugsnagErrorBoundary = reactPlugin
  ? reactPlugin.createErrorBoundary(React)
  : ({ children }: { children: React.ReactNode }) => <>{children}</>;

export { Event as BugsnagEvent };

export default Bugsnag;
